import { Link } from "react-router-dom";
import { CheckCircle2, Phone, Home } from "lucide-react";
import Seo from "../components/Seo";
import { Container, Cta, Eyebrow, WhatsappIcon } from "../components/ui-kit";
import { CONTACT } from "../mock";

const ThankYou = () => (
  <main className="bg-canvas min-h-[70vh] flex items-center" data-testid="thankyou-page">
    <Seo
      title="Teşekkürler — Talebiniz Alındı | Koşan Düğme"
      description="Talebiniz başarıyla iletildi. Ekibimiz en kısa sürede size dönüş yapacaktır."
      path="/tesekkurler"
      noindex
    />
    <Container className="py-20 lg:py-28 max-w-2xl text-center">
      <div className="inline-flex w-16 h-16 rounded-full bg-brand/10 items-center justify-center text-brand mb-8">
        <CheckCircle2 size={34} strokeWidth={1.6} />
      </div>
      <Eyebrow className="block">Teşekkürler</Eyebrow>
      <h1 className="font-display font-light text-4xl sm:text-5xl leading-[1.06] text-ink mt-5">
        Talebiniz bize <span className="font-medium">ulaştı.</span>
      </h1>
      <p className="text-ink2 leading-relaxed mt-6">
        Mesajınızı aldık. Ekibimiz talebinizi aynı gün değerlendirip en kısa sürede size dönüş yapacaktır. Acele bir
        durumunuz varsa doğrudan arayabilir ya da WhatsApp hattımızdan yazabilirsiniz.
      </p>
      <div className="flex flex-wrap items-center justify-center gap-4 mt-10">
        <Cta to="/" data-testid="thankyou-home-cta">
          <Home size={16} /> Anasayfa
        </Cta>
        <a
          href={CONTACT.whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="thankyou-whatsapp"
          className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-[#25D366] hover:bg-[#1ebe5b] text-white text-[13px] font-semibold transition-colors"
        >
          <WhatsappIcon size={16} /> WhatsApp'tan yaz
        </a>
        <a
          href={CONTACT.phoneHref}
          className="inline-flex items-center gap-2 text-[13px] font-semibold text-ink hover:text-brand transition-colors"
          data-testid="thankyou-phone"
        >
          <Phone size={15} className="text-brand" /> {CONTACT.phone}
        </a>
      </div>
      <div className="mt-12 pt-8 border-t border-line">
        <Link to="/urunler" className="text-[13px] font-semibold text-ink2 hover:text-brand transition-colors" data-testid="thankyou-products-link">
          Bu arada ürün kataloğumuza göz atın →
        </Link>
      </div>
    </Container>
  </main>
);

export default ThankYou;
